import { routeConfig } from "@/routes/route";
import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";

const LazyLoad = (path: string) => {
  const Comp = lazy(() => import("@BZA/" + path));
  return (
    <Suspense fallback={<></>}>
      <Comp />
    </Suspense>
  );
};

export const useHelpCenterRouterMap = (): routeConfig[] => {
  const { t } = useTranslation();

  return [
    {
      path: "/help",
      name: t("Basics.LeftMenu.HelpCenter"),
      key: "helpListKey",
      element: LazyLoad("HelpCenter/helpCenter"),
      isHidden: true
    },
    {
      path: "/help/feedback",
      name: t("Basics.LeftMenu.Feedback"),
      key: "feedbackKey",
      element: LazyLoad("HelpCenter/feedback"),
      isHidden: true
    }
  ];
};

// 保留原有的导出以确保向后兼容
export const HelpCenterRouterMap: routeConfig[] = [
  {
    path: "/help",
    name: "帮助中心",
    key: "helpListKey",
    element: LazyLoad("HelpCenter/helpCenter"),
    isHidden: true
  },
  {
    path: "/help/feedback",
    name: "问题反馈",
    key: "feedbackKey",
    element: LazyLoad("HelpCenter/feedback"),
    isHidden: true
  }
];
